import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DateRange } from '@angular/material/datepicker';
import { Chart, registerables } from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom';

@Component({
  selector: 'app-reporting-chart',
  templateUrl: './reporting-chart.component.html',
  styleUrls: ['./reporting-chart.component.scss']
})
export class ReportingChartComponent {
  @ViewChild('chartCanvas') chartCanvas: ElementRef | undefined;
  @Input() data!: { [key: string]: number };
  @Output() dateRangeSelected = new EventEmitter<{ start: String, end: String }>();
  chart!: Chart;
  mask: Boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      if (this.chart) {
        this.setChartData();
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.chartCanvas?.nativeElement) {
      this.createChart();
    }
  }

  dateRangeChange(startDate: HTMLInputElement, endDate: HTMLInputElement): void {
    const fechaInicio = startDate.value ? new Date(startDate.value) : null;
    const fechaFin = endDate.value ? new Date(endDate.value) : null;

    if (fechaInicio && fechaFin) {
    fechaInicio.setHours(0, 0, 0, 0);
    fechaFin.setHours(23, 59, 59, 999);
    const startFormatted = this.formatDateToUTC(fechaInicio);
    const endFormatted = this.formatDateToUTC(fechaFin);
    this.dateRangeSelected.emit({ start: startFormatted, end: endFormatted });
    }
  }

  formatDateToUTC(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

   createChart(): void {
    const ctx = (this.chartCanvas?.nativeElement as HTMLCanvasElement)
      const backgroundColorPlugin = {
        id: 'backgroundColorPlugin',
        beforeDraw: (chart: { ctx: any; chartArea: any; }) => {
          const { ctx, chartArea } = chart;
          if (chartArea) {
            ctx.save();
            ctx.fillStyle = '#f3f3f3';
            ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
            ctx.restore();
          }
        }
      };
      Chart.register(backgroundColorPlugin);
      Chart.register(zoomPlugin);
      
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: [],
          datasets: [
            {
              label: 'Valor',
              data: [],
              backgroundColor: 'rgba(255, 213, 14, .5)',
              borderColor: '$primaryBlack',
              borderWidth: 1, 
              borderRadius: 15,
              hoverBackgroundColor: '#BBBFB8', 
              hoverBorderColor: '$primaryBlack', 
              barPercentage: 0.8, 
              categoryPercentage: 0.9,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
              position: 'top',
            },
            zoom: {
              zoom: {
                mode: 'x',
                drag: {
                  enabled: true, 
                  backgroundColor: 'rgba(0, 0, 0, 0.25)',
                  borderColor: 'rgba(0, 0, 0, 0.5)',
                  borderWidth: 1
                }
              }
            },tooltip: {
              enabled: true,
              caretPadding: 10,
              intersect: false,
              mode: 'index',
              axis: 'x'
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              grid: {
                display: false,
              },
            },
            x: {
              grid: {
                display: false,
              }
            },
          },
        },
      });
      this.addDoubleClickListener(ctx);

      this.setChartData();
    }

    addDoubleClickListener(ctx:any) {
      ctx.addEventListener('dblclick', () => {
        this.chart.resetZoom();  
      });
    }
  

    setChartData() {
      const segments = this.data;

      this.chart.data.labels = Object.keys(segments).map((date: string) => {
        const dateObject = new Date(date);  
        return date;  
      });
    
      this.chart.data.datasets[0].data = Object.values(segments); 
    
      this.chart.update();
    }

}
